import React, { useState, useEffect,Fragment } from 'react'
import { Button, Nav, Collapse, Navbar, Container } from 'react-bootstrap'
import NavbarHome from '../components/NavbarHome'
import Card from '../components/Card'
import Logo from '../components/partials/components/logo'
import { Link } from 'react-router-dom'
import LanguageSwitcher from '../components/LanguageSwitcher'
import { useLanguage } from '../i18n/LanguageContext'

//uiKit
import Accordions from './uikit/accordion'
import Alerts from './uikit/alert'
import Badges from './uikit/badge'
import Breadcrumbs from './uikit/breadcrumb'
import Buttons from './uikit/button'
import ButtonGroups from './uikit/buttons-group'
import Calenders from './uikit/calender'
import Cards from './uikit/card'
import Carousels from './uikit/carousel'
import DropDowns from './uikit/dropdowns'
import ListGroups from './uikit/list-group'
import Modals from './uikit/modal'
import Navbars from './uikit/navbar'
import Navs from './uikit/nav'
import OffCanvass from './uikit/off-canvas'
import Paginations from './uikit/pagination'
import Popovers from './uikit/popovers'
import Scrollspys from './uikit/scrollspy'
import Spinnerss from './uikit/spinner'
import Toasts from './uikit/toast'
import Tooltips from './uikit/tooltip'
import Progresss from './uikit/progress'
//form
import DisabledForms from './uikit/disabled-form'
import AFormControls from './uikit/alternate-form-control'
import Sizings from './uikit/sizing'
import InputGroups from './uikit/input-group'
import FloatingLables from './uikit/floating-lable'
import AFloatingLables from './uikit/alternate-floating-lable'
import ToggleBtns from './uikit/toggle-btn'
import Validations from './uikit/validation'
import Overview from './uikit/form-overview'

// content
import Typographys from './uikit/typography'
import Images from './uikit/image'
import Figures from './uikit/figure'
import Tables from './uikit/table'

//prism
import 'prismjs';
import '../../node_modules/prismjs/themes/prism-okaidia.css'

// SliderTab
import SliderTab from '../plugins/slider-tabs'

// Import selectors & action from setting store
import * as SettingSelector from "../store/setting/selectors";

// Redux Selector / Action
import { useSelector } from "react-redux";



const Home = () => {
  const appName = useSelector(SettingSelector.app_name);
  const { t } = useLanguage();
    // collapse
    const [open, setOpen] = useState(false);
    const [open1, setOpen1] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [open3, setOpen3] = useState(false);

    useEffect(() => {
      return () => {
        setTimeout(() => {
          Array.from(
            document.querySelectorAll('[data-toggle="slider-tab"]'),
            (elem) => {
              return new SliderTab(elem);
            }
          );
        }, 100);
      };
    });

    return (
        <Fragment>
        <span className="uisheet screen-darken"></span>
        <div className="header quizify-hero-header">
          <div className="main-img">
            <div className="container">
              <Logo className="quizify-hero-logo" />
              <h1 className="quizify-hero-title mt-4 mb-2">
                <span data-setting="app_name">{appName}</span>
              </h1>
              <h5 className="quizify-hero-tagline text-white mb-5">
                {t.home.tagline}
              </h5>
              <div className="quizify-hero-actions d-flex justify-content-center align-items-center">
                <div className="quizify-hero-action-wrap">
                  <Link
                    className="quizify-hero-action quizify-hero-primary-action btn btn-light bg-white d-flex"
                    to="/dashboard"
                    target="_blank"
                  >
                    <svg
                      width="22"
                      height="22"
                      className="quizify-hero-action-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                      ></path>
                    </svg>
                    <span>{t.home.dashboardDemo}</span>
                  </Link>
                </div>
                {/* <div className="quizify-hero-action-wrap">
                     <Button bsPrefix="quizify-hero-action quizify-hero-secondary-action btn btn-light bg-white d-flex" target="_blank" href="https://github.com/iqonic-design/hope-ui-react-dashboard">
                        <img className="quizify-hero-action-icon" src={github} width="24px" height="24px" alt="github"/>
                        <span className="text-danger fw-bold">{t.home.githubPrefix}</span>
                        <span>{t.home.githubSuffix}</span>
                    </Button>
                </div> */}

            </div>
              <div className="home-development-warning">
                {t.home.developmentWarning}
              </div>
          </div>
          </div>
          <Container>
            <NavbarHome/>
          </Container>
          
        </div>
        <div className="floating-language-switcher">
          <LanguageSwitcher placement="floating" />
        </div>
        <div id="back-to-top" style={{ display: "none" }}>
          <Button size="xs" variant="primary  p-0 position-fixed top" href="#top">
            <svg
              width="30"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 15.5L12 8.5L19 15.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </Button>
        </div>
        </Fragment>
    )
}

export default Home;
